<template>
	<h2 :class="$style['dashboard-form-title']">
		<slot />
	</h2>
</template>
<script>
export default {
	name: 'DashboardFormTitle'
}
</script>
<style lang="scss" module>

	// .dashboard-form-title {
	// 	font-size: 18px;
	// 	color: getColor(text);
	// 	font-weight: 600;
	// 	margin: 0;
	// 	padding: 0;
	// 	padding: 15px 0;
	// }
	.dashboard-form-title {
		font-size: 24px;
		font-weight: bold;
		color: getColor(text);
		margin: 0;
		padding: 0;
		padding-bottom: $gutter * 2;
		padding-right: $gutter * 2;
	}
</style>
